import React from 'react';
import { createStyles, FormControl, FormHelperText, Icon, IconButton, InputAdornment,
    InputLabel, makeStyles, OutlinedInput } from '@material-ui/core';

import { UserModel } from '../../../Models/UserModel';
import { UserContext } from '../UserContext';
import { validatePassword } from '../../../shared/operators';

const useStyles = makeStyles(() => createStyles({
    itens: {
        marginTop: '20px',
        width: '100%'
    },
}));

export function PasswordFields() {
    const classes = useStyles();

    const userContext = React.useContext(UserContext);

    const [errorPassword, setErrorPassword] = React.useState<boolean>(false);
    const [errorPasswordConfirm, setErrorPasswordConfirm] = React.useState<boolean>(false);
    const [showPassword, setShowPassword] = React.useState<boolean>(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = React.useState<boolean>(false);
    const [confirmPassword, setConfirmPassword] = React.useState<string>('');

    React.useEffect(() => {
        userContext.setDisableSubmit(errorPassword || errorPasswordConfirm || !userContext.user.password || !confirmPassword);
    }, [errorPassword, errorPasswordConfirm, userContext.user.password, confirmPassword]);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleChangeBlock = (e: React.ClipboardEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const handleChange = (prop: keyof UserModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        userContext.setUser({ ...userContext.user, [prop]: event.target.value });
    };

    const validPassword = () => {
        if (userContext.user.password)
            setErrorPassword(!validatePassword(userContext.user.password ?? ''));
    };

    const validPasswordConfirm = () => {
        if (userContext.user.password && confirmPassword)
            setErrorPasswordConfirm(userContext.user.password !== confirmPassword);
    };

    return (
        <>
            <FormControl className={classes.itens} variant="outlined">
                <InputLabel
                    error={errorPassword}
                    htmlFor="password">
                    Senha
                </InputLabel>
                <OutlinedInput
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    onCut={handleChangeBlock}
                    onCopy={handleChangeBlock}
                    onPaste={handleChangeBlock}
                    value={userContext.user.password}
                    onChange={handleChange('password')}
                    onKeyUp={() => { validPassword(); validPasswordConfirm(); }}
                    error={errorPassword}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="pressione para exibir a senha"
                                onClick={() => setShowPassword(!showPassword)}
                                onMouseDown={handleMouseDownPassword}>
                                {showPassword
                                    ? <Icon>visibility</Icon>
                                    : <Icon>visibility_off</Icon>}
                            </IconButton>
                        </InputAdornment>
                    }
                    labelWidth={50} />
                {errorPassword && (
                    <FormHelperText error id="error-text-password">
                        {userContext.user.password
                            ? 'Sua senha não atende aos critérios mínimos de segurança. Ela deve ter pelo menos 12 caracteres, incluindo letras maiúsculas, minúsculas, números e pelo menos um caractere especial.'
                            : 'Campo obrigatório'}
                    </FormHelperText>
                )}
            </FormControl>
            <FormControl className={classes.itens} variant="outlined">
                <InputLabel
                    error={errorPasswordConfirm}
                    htmlFor="password-confirm">
                    Confirme sua senha
                </InputLabel>
                <OutlinedInput
                    id="password-confirm"
                    type={showPasswordConfirm ? 'text' : 'password'}
                    onCut={handleChangeBlock}
                    onCopy={handleChangeBlock}
                    onPaste={handleChangeBlock}
                    value={confirmPassword}
                    onChange={(value) => setConfirmPassword(value.target.value)}
                    onKeyUp={() => { validPassword(); validPasswordConfirm(); }}
                    error={errorPasswordConfirm}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="pressione para exibir a senha"
                                onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                onMouseDown={handleMouseDownPassword}>
                                {showPasswordConfirm
                                    ? <Icon>visibility</Icon>
                                    : <Icon>visibility_off</Icon>}
                            </IconButton>
                        </InputAdornment>
                    }
                    labelWidth={150} />
                {errorPasswordConfirm && (
                    <FormHelperText error id="error-text-password-confirm">
                        As senhas informadas não coincidem. Por favor, tente novamente.
                    </FormHelperText>
                )}
            </FormControl>
        </>
    );
}